
import { useEffect } from 'react'
import Select from 'react-select'
import { MaintainByDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { useTranslation } from 'react-i18next'

export const MaintainByDataDDL = (props) => {
    const { MaintainBy, setMaintainBy, WardName, rowData, Flag, Language, M_AssetTypeID } = props
    const { t } = useTranslation()
    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_AssetTypeID: M_AssetTypeID,
            M_UserID: UserID,
            token: token,
            Language: Language.Label,
        }
        { Language.Label != '' && dispatch(MaintainByDDLAPI({ data })) }
    }, [Language.Label])

    const { MaintainByDDL } = useSelector(state => state.MaintainByDDLData)

    useEffect(() => {
        handleMaintainByDDL()
    }, [MaintainByDDL])

    const handleMaintainByDDL = () => {
        if (MaintainByDDL && MaintainByDDL.table && MaintainByDDL.table.length > 0) {
            let list = MaintainByDDL.table.map((item, index) => ({
                value: item.m_IndicatorID,
                label: item.indicatorName,
            }))

            setMaintainBy({
                DDL: list,
                ID: Flag === 'Update' ? rowData.maintainByIndicatorAgencyID : 0,
                Label: Flag === 'Update' ? rowData.indicatorName : "Select...",
            })
        }
        else {
            setMaintainBy({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>{t('Dashboard.Pcmc_Assets.Maintain_By')}</b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width3"
                isSearchable
                maxMenuHeight={150}
                value={{ value: MaintainBy.ID, label: MaintainBy.Label }}
                onChange={(e) => {
                    e ?
                        setMaintainBy({ ...MaintainBy, ID: e.value, Label: e.label })
                        :
                        setMaintainBy({ ...MaintainBy, ID: 0, Label: "Select..." })

                }}
                options={MaintainBy.DDL}
            />
        </div>
    )
}